import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { take, tap } from 'rxjs';

import { PermissionsService } from '@shared/services/permissions.service';
import {
  ConfigurationAdmin,
  PermissionGrants,
  QuestionnaireAdmin,
} from '@shared/interfaces/permissions.interface';

export const canActivateConfigurationRouteFn: CanActivateFn = () => {
  const _router = inject(Router);
  const _permissionService = inject(PermissionsService);
  return _permissionService
    .observeUserPermissions(
      [ConfigurationAdmin],
      [
        PermissionGrants.CanView
      ],
    )
    .pipe(
      take(1),
      tap((hasPermission) => !hasPermission && _router.navigate(['/welcome'])),
    );
};

export const canQuestionnaireConfigurationRouteFn: CanActivateFn = () => {
  const _router = inject(Router);
  const _permissionService = inject(PermissionsService);
  return _permissionService
    .observeUserPermissions(
      [QuestionnaireAdmin],
      [
        PermissionGrants.CanView
      ],
    )
    .pipe(
      take(1),
      tap((hasPermission) => !hasPermission && _router.navigate(['/welcome'])),
    );
};
